import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import HeroSection from './components/HeroSection';
import VideoGrid from './components/VideoGrid';
import CategoryCards from './components/CategoryCards';
import NewsList from './components/NewsList';
import CTASection from './components/CTASection';
import FAQSection from './components/FAQSection';
import { useEffect } from 'react';

const websiteJsonLd = {
  '@context': 'https://schema.org',
  '@type': 'WebSite',
  name: '黑料视频',
  url: 'http://chiguabao.cn/',
  description: '黑料视频在线观看与下载，黑料24小时不打烊每日更新，国产黑料视频实时追踪，黑料女神攻略等热门内容，一站式浏览最新黑料爆料。',
  potentialAction: {
    '@type': 'SearchAction',
    target: 'http://chiguabao.cn/search?q={search_term_string}',
    'query-input': 'required name=search_term_string',
  },
};

const organizationJsonLd = {
  '@context': 'https://schema.org',
  '@type': 'Organization',
  name: '黑料视频',
  url: 'http://chiguabao.cn/',
  description: '国产黑料视频实时追踪平台，24小时不打烊每日更新最新娱乐八卦爆料',
  logo: 'http://chiguabao.cn/logo.png',
};

export default function Home() {
  useEffect(() => {
    document.title = '黑料视频 - 黑料视频在线观看与下载，黑料24小时不打烊每日更新';
    const metaDescription = document.querySelector('meta[name="description"]');
    if (metaDescription) {
      metaDescription.setAttribute('content', '黑料视频在线观看与下载，黑料24小时不打烊每日更新，国产黑料视频实时追踪。黑料女神攻略等热门内容，一站式浏览最新黑料爆料。');
    }
    const metaKeywords = document.querySelector('meta[name="keywords"]');
    if (metaKeywords) {
      metaKeywords.setAttribute('content', '黑料视频,黑料视频在线观看,黑料视频下载,黑料24小时不打烊,国产黑料视频,黑料女神攻略,吃瓜黑料');
    }
  }, []);

  return (
    <>
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{ __html: JSON.stringify(websiteJsonLd) }}
      />
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{ __html: JSON.stringify(organizationJsonLd) }}
      />
      <div className="min-h-screen bg-background-50">
        <Navbar />
        <main>
          <div className="pt-6 md:pt-8">
            <HeroSection />
          </div>
          <VideoGrid />
          <CategoryCards />
          <NewsList />
          <CTASection />
          <FAQSection />
        </main>
        <Footer />
      </div>
    </>
  );
}